import React, { useState, useEffect } from "react";
import HomepageModal from "../HomepageModal";

const PopUpOnce = ({ values }) => {
  const [visible, setVisible] = useState(false);
  const [popups, setPopups] = useState(values);

  useEffect(() => {
    // Show popup instantly if not shown before
    const popStatus = localStorage.getItem("pop_status");
    if (!popStatus) {
      setVisible(true);
      localStorage.setItem("pop_status", "1");
    }

    // Replace default popup with API data if available
    if (values?.length > 0) {
      setPopups(values);
    }

    // Clear localStorage on page unload
    const handleUnload = () => localStorage.removeItem("pop_status");
    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, [values]);

  if (!visible) return null;

  return (
    <>
      {popups.map((popup, index) => (
        <HomepageModal
          key={popup.id}
          Iindex={index}
          iTitle={popup.Title}
          iDocPath={popup.DocPath}
          iLink={popup.external_link}
          iZoom={popup.zoom_level}
        />
      ))}
    </>
  );
};

export default PopUpOnce;
